import axios from 'axios';
import qs from 'qs';

/**
 * タスク履歴一覧取得
 */
export const getSiteTaskHistory = (
  constructId: number,
  choiceItem?: number[],
  chargeUserId?: number,
  page?: number,
  displayLimit?: number
) => {
  return axios
    .get(`/api/v1/task-history`, {
      headers: {
        withCredentials: true
      },
      params: {
        construct_id: constructId,
        choice_item: choiceItem,
        charge_user_id: chargeUserId,
        page: page,
        display_limit: displayLimit
      },
      paramsSerializer: params =>
        qs.stringify(params, { arrayFormat: 'repeat' })
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * タスク履歴差分取得
 */
export const getSiteTaskHistoryDiff = (siteTaskHistoryId: number) => {
  return axios
    .get(`/api/v1/task-history/diff/${siteTaskHistoryId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
